import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'captionBid'
})
export class CaptionBidPipe implements PipeTransform {

  private captionLabels: Record<string, string> = {
    LEADING_BID: 'Leading Bid',
    TIE_WINNER: 'Tie Bid',
    RESERVE_MET: 'Reserve Met',
    BELOW_RESERVE: 'Below Reserve',
    LIVE_EVENT_BID: 'Live Event Bid',
    BID_EXTENSION: 'Bid Extension',
    STRAIGHT_BID: 'Straight Bid',
    BUY_NOW: 'Buy Now',
  };

  transform(value: string): string {
    return this.captionLabels[value] ?? value;
  }
}
